import { useApi } from '@api/ApiProvider'
import type { PointOfInterest } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'
import { useQuery } from '@tanstack/react-query'

// La API no tiene "ver un lugar": se usa la lista completa (sin paginar) con la misma clave que
// el mapa (['pois', idioma]), así que si ya se abrió el mapa sale de caché.
export const usePlaces = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: ['pois', locale], queryFn: () => api.pointsOfInterest(locale) })
}

export const useMunicipalities = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: ['municipalities', locale], queryFn: () => api.municipalities(locale) })
}

export const useLocalities = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: ['localities', locale], queryFn: () => api.localities(locale) })
}

// Comunidades del Camino, en su orden (las pestañas de la ficha de especie).
export const useRegions = () => {
	const api = useApi()
	const { locale } = useI18n()
	return useQuery({ queryKey: ['regions', locale], queryFn: () => api.regions(locale) })
}

export const findPlace = (places: PointOfInterest[], id: string): PointOfInterest | null =>
	places.find((place) => place.id === id) ?? null
